export default __webpack_public_path__ + "static/media/drone.1b4798f4.png";